import React, { useEffect, useMemo, useRef } from "react";
import { CreatedBy, Page } from "../PublicViewRender";
import SingleFormPage from "./SingleFormPage";
import { calc } from "@chakra-ui/react";
import { getGoogleFormData } from "../../../../../utils/helpers";
import FormImagesLayout from "./FormImagesLayout";
import formHeadingBg from "../../../../../assets/formHeading.jpg";
import IndexPage from "./IndexPage";

const FormPages = React.forwardRef(
  ({ number, cWidth, backendData, isPdf, setTotalPages }, ref) => {
    let width = isPdf ? 896 : cWidth;
    const rowHRef = useRef();
    const remarkHref = useRef();
    // console.log("BCKEND DATA", backendData,width, {isPdf});
    const data = [
      {
        heading: "Heading",

        tableData: [
          { label: "Label1", value: "Value1" },
          { label: "Label2", value: "Value2" },
          { label: "Label3", value: "Value3" },
          { label: "Label4", value: "Value4" },
          { label: "Label5", value: "Value5" },
          { label: "Label6", value: "Value6" },
          { label: "Label7", value: "Value7" },
          { label: "Label8", value: "Value8" },
          { label: "Label9", value: "Value9" },
          { label: "Label10", value: "Value10" },
          { label: "Label8", value: "Value8" },
          { label: "Label9", value: "Value9" },
          { label: "Label10", value: "Value10" },
          { label: "Label10", value: "Value10" },
          { label: "Label8", value: "Value8" },
        ],
        remarks: "Heelo from remarks",
        images: [
          "https://plus.unsplash.com/premium_photo-1700996706577-c299866f294e?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          "https://images.unsplash.com/photo-1758566486732-c6bcc1d080e1?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          "https://images.unsplash.com/photo-1758506972145-fdcac3daba97?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwxOXx8fGVufDB8fHx8fA%3D%3D",
          "https://images.unsplash.com/photo-1758299892041-28192a311d2a?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          "https://images.unsplash.com/photo-1758506972145-fdcac3daba97?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwxOXx8fGVufDB8fHx8fA%3D%3D",
          "https://images.unsplash.com/photo-1758566486732-c6bcc1d080e1?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          "https://images.unsplash.com/photo-1758566486732-c6bcc1d080e1?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        ],
      },
    ];

    let finalData = useMemo(() => {
      const val = isPdf
        ? getGoogleFormData(backendData.formData, width)
        : getGoogleFormData(backendData.formData, width);
      setTotalPages && setTotalPages(val?.length || 0);
      return val;
    }, [backendData.formData, width]);
    useEffect(() => {}, [width]);

    console.log("CURRENT WIDTH", width, finalData); // 2.28
    const textSize = width / 25.81;
    const w = width / 1.6;
    // const h = ;
    // finalData = finalData.splice(0,5)
    // let temp = finalData?.splice(0,5) || [];
    return (
      <>
        {finalData?.map((val) => {
          if (val.isImage) {
            // if(isPdf) return null;
            return (
              <div
                className={`w-full h-full bg-white ${isPdf && "pdfSection"}`}
                ref={ref}
              >
                <FormImagesLayout
                  images={val.images}
                  isVideo={val?.isVideo}
                  heading={val?.heading}
                  createdBy={` ${backendData?.username}`}
                  creationDate={backendData?.createdAt}
                  isPdf={isPdf}
                />
              </div>
            );
          } else if (val?.isHeadingPage) {
            return (
              <div
                className={`w-full h-full relative ${isPdf && "pdfSection"} `}
                ref={ref}
              >
                <div
                  style={{
                    backgroundImage: `url(${formHeadingBg}) `,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    // backgroun
                  }}
                  className="flex items-center justify-center h-full"
                >
                  <div
                    style={{ width: `${w}px`, aspectRatio: "5/1" }}
                    className="flex items-center justify-center "
                  >
                    <h2
                      style={{ fontSize: textSize }}
                      className={` text-white text-center ${
                        isPdf && " relative bottom-3"
                      } `}
                    >
                      {val?.heading}
                    </h2>
                  </div>
                </div>

                <div
                  className={`absolute ${
                    isPdf ? "-bottom-1 -left-1" : "-bottom-2 -left-3"
                  }  w-fit text-nowrap `}
                >
                  <CreatedBy
                    username={` ${backendData?.username}`}
                    date={backendData?.createdAt}
                    isPdf={isPdf}
                  />
                  {/* <CreatedBy username={createdBy} date={creationDate}  isPdf={isPdf}/> */}
                </div>
              </div>
            );
          } else if (val?.isIntro) {
            return (
              <div
                className={`w-full h-full bg-white ${isPdf && "pdfSection"}`}
                ref={ref}
              >
                <IndexPage
                  heading={val?.heading}
                  fields={val?.fields}
                  width={width}
                  createdBy={` ${backendData?.username}`}
                  creationDate={backendData?.createdAt}
                  isPdf={isPdf}
                />
              </div>
            );
          } else {
            return (
              <div
                className={`w-full h-full bg-white ${isPdf && "pdfSection"}`}
                ref={ref}
              >
                <SingleFormPage
                  heading={val?.heading}
                  tableData={val?.tableData}
                  remark={val?.remarks}
                  createdBy={` ${backendData?.username}`}
                  creationDate={backendData?.createdAt}
                  isPdf={isPdf}
                />
              </div>
            );
          }
        })}
      </>
    );
  },
);

export default FormPages;
